<div class="loading-bar-wrapper" [class.sticky]="sticky">
  <markant-progress-bar *ngIf="updating" indeterminate="true" class=""></markant-progress-bar>
</div>
